export default "__VITE_ASSET__CiiT9uM4__"